import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children"];
import React from 'react';
import { Box } from '@hub/box';
import { Stack } from '@hub/stack';
import { CoreContainer } from '@hub/core-container';
import { HeaderPrimaryMenuButton } from './header-primary-menu-button';
import { HeaderTopStrip } from './header-top-strip';
import { HeaderLogo } from './header-logo';
import { HeaderSearchButton } from './header-search-button';
import { HeaderMembership } from './header-membership';
import { HeaderBackButton } from './header-back-button';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderContext = /*#__PURE__*/React.createContext({});
export const useHeaderProps = () => {
  return React.useContext(HeaderContext).props || {};
};
export const HeaderMenus = _ref => {
  let {
    children
  } = _ref;
  const {
    props
  } = React.useContext(HeaderContext);
  if (props !== null && props !== void 0 && props.taskMode) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const HeaderInner = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    props
  } = React.useContext(HeaderContext);
  if (props !== null && props !== void 0 && props.taskMode) {
    return null;
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const HeaderOuter = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export const Header = _ref4 => {
  let {
      children
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded);
  const isTaskMode = props.taskMode;
  const [menusChildren, innerChildren, outerChildren] = React.useMemo(() => {
    const menusChildren = [];
    const innerChildren = [];
    const outerChildren = [];
    const callback = child => {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return;
      }
      if (child.type === React.Fragment) {
        React.Children.forEach(child.props.children, callback);
      }
      if (child.type === HeaderMenus) {
        menusChildren.push(child);
      }
      if (child.type === HeaderInner) {
        innerChildren.push(child);
      }
      if (child.type === HeaderOuter) {
        outerChildren.push(child);
      }
    };
    React.Children.forEach(children, callback);
    return [menusChildren, innerChildren, outerChildren];
  }, [children]);
  return /*#__PURE__*/_jsxs(HeaderContext.Provider, {
    value: {
      props
    },
    children: [/*#__PURE__*/_jsx(Box, {
      backgroundColor: "surfaceBrandPrimary",
      display: "flow-root",
      "data-id": "header_header_Header_Box",
      children: /*#__PURE__*/_jsxs(Box, {
        "data-id": "header_header_Header_Box_Box_1",
        children: [/*#__PURE__*/_jsx(HeaderTopStrip, {
          "data-id": "header_header_Header_Box_HeaderTopStrip"
        }), /*#__PURE__*/_jsx(CoreContainer, {
          "data-id": "header_header_Header_Box_CoreContainer",
          children: /*#__PURE__*/_jsxs(Box, {
            "data-id": "header_header_Header_CoreContainer_Box",
            children: [menusChildren, isTaskMode ? /*#__PURE__*/_jsxs(Stack, {
              shouldWrapChildren: false,
              direction: "row",
              align: "center",
              justify: "space-between",
              wrap: ['wrap', null, 'nowrap'],
              columnGap: "spacing-md",
              rowGap: "spacing-sm",
              lineHeight: 0,
              marginTop: ['spacing-md', null, 'spacing-lg'],
              marginBottom: ['spacing-md', null, 'spacing-lg'],
              sx: {
                minWidth: 'calc(var(--chakra-sizes-size-21) - 2 * var(--chakra-space-spacing-lg))'
              },
              "data-id": "header_header_Header_Stack",
              children: [/*#__PURE__*/_jsx(Box, {
                flex: 1,
                minWidth: "size-2",
                "data-id": "header_header_Header_Stack_Box",
                children: /*#__PURE__*/_jsx(HeaderBackButton, {
                  "data-id": "header_header_Header_Box_HeaderBackButton"
                })
              }), /*#__PURE__*/_jsx(Box, {
                sx: {
                  flexGrow: 0
                },
                "data-id": "header_header_Header_Stack_Box",
                children: /*#__PURE__*/_jsx(HeaderLogo, {
                  "data-id": "header_header_Header_Box_HeaderLogo"
                })
              }), /*#__PURE__*/_jsx(Box, {
                flex: 1,
                "data-id": "header_header_Header_Stack_Box"
              })]
            }) : /*#__PURE__*/_jsxs(Stack, {
              shouldWrapChildren: false,
              direction: "row",
              align: "center",
              justify: "space-between",
              wrap: ['wrap', null, 'nowrap'],
              columnGap: "spacing-md",
              rowGap: "spacing-sm",
              lineHeight: 0,
              marginTop: ['spacing-md', null, 'spacing-lg'],
              marginBottom: ['spacing-md', null, 'spacing-lg'],
              sx: {
                minWidth: 'calc(var(--chakra-sizes-size-21) - 2 * var(--chakra-space-spacing-lg))'
              },
              "data-id": "header_header_Header_Stack",
              children: [/*#__PURE__*/_jsx(Box, {
                width: "size-8",
                sx: {
                  flexGrow: 0,
                  order: 1
                },
                "data-id": "header_header_Header_Stack_Box",
                children: /*#__PURE__*/_jsx(HeaderPrimaryMenuButton, {
                  "data-id": "header_header_Header_Box_HeaderPrimaryMenuButton"
                })
              }), /*#__PURE__*/_jsx(Box, {
                sx: {
                  flexGrow: [1, null, 0],
                  order: 2,
                  display: 'flex',
                  justifyContent: ['center', null, 'left']
                },
                width: [null, null, // in Desktop, the menu & logo combined width must match the membership
                // width so that the search button will be centered:
                //   logoWidth = (membershipWidth - menuWidth - columnGap)
                "calc(var(--chakra-sizes-size-16) - var(--chakra-sizes-size-8) - var(--chakra-space-spacing-md))"],
                "data-id": "header_header_Header_Stack_Box",
                children: /*#__PURE__*/_jsx(HeaderLogo, {
                  "data-id": "header_header_Header_Box_HeaderLogo"
                })
              }), /*#__PURE__*/_jsx(Box, {
                width: ['calc(100vw - 2 * var(--chakra-space-spacing-lg))', null, 'auto'],
                sx: {
                  order: [4, null, 3],
                  textAlign: 'center'
                },
                "data-id": "header_header_Header_Stack_Box",
                children: /*#__PURE__*/_jsx(HeaderSearchButton, {
                  "data-id": "header_header_Header_Box_HeaderSearchButton"
                })
              }), /*#__PURE__*/_jsx(Box, {
                width: ['size-8', null, 'size-16'],
                sx: {
                  flexGrow: 0,
                  order: [3, null, 4],
                  textAlign: 'right',
                  textWrap: 'nowrap'
                },
                "data-id": "header_header_Header_Stack_Box",
                children: props.country === 'Australia' && /*#__PURE__*/_jsx(HeaderMembership, {
                  "data-id": "header_header_Header_HeaderMembership"
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Box, {
          "data-id": "header_header_Header_Box_Box",
          children: innerChildren
        })]
      })
    }), /*#__PURE__*/_jsx(Box, {
      marginBottom: ['spacing-md', null, 'spacing-lg'],
      "data-id": "header_header_Header_Box_21",
      children: outerChildren
    })]
  });
};